export const styles = {
  root: {
    position: 'sticky',
    padding: '24px 24px 12px 24px',
    top: 0,
    zIndex: 10,
    backgroundColor: '#eee',
  },
}
